import FilesHeader from './FilesHeader';
import './FilesHeader.scss';

export default FilesHeader;
